import { render, staticRenderFns } from "./IconSave.vue?vue&type=template&id=0f58269f"
import script from "./IconSave.vue?vue&type=script&lang=js"
export * from "./IconSave.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports